export enum AWSUserStatus {
    Created = "UNCONFIRMED",
    Confirmed = "CONFIRMED",
    ThirdParty = "EXTERNAL_PROVIDER",
    Inactive = "ARCHIVED",
    Unknown = "UNKNOWN",
    ResetRequired = "RESET_REQUIRED",
    TemporaryPassword = "FORCE_CHANGE_PASSWORD"
}